__turbopack_context__.v({
  "video": "qAWSgW_video",
});
